export * from "./profile";
export * from "./fund";
export * from "./transaction";
export * from "./mandate";
export * from "./onboarding";
export * from "./plan";
export * from "./client";
export * from "./bank-service-capabilities";
export * from "./upi-intent";
export * from "./products";
export * from "./mf-central";

export const EMPTY_PAGINATED_RESPONSE = {
  next: null,
  previous: null,
  results: [],
  count: 0,
};

export const CRESO_OFFICE_DETAILS = {
  name: "Creso Technologies Private Limited",
  address:
    "705, Damji Shamji Business Galleria, LBS Road, Next to Toyo House, Kanjurmarg, Mumbai - 400078",
  phone: "9082930322",
};

export const CRESO_ARN = "321367";

/** Sentinel "since forever" start date, for report/date-range calls that need a
 * real start_date to mean "the client's/family's full history". */
export const EPOCH_DATE = "1970-01-01";
